import type { ICancellationToken } from '@cian/http-api';

import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type ISearchOffersDesktopResponse200,
  type ISearchOffersDesktopResponse400,
  type TSearchOffersDesktopRequest,
  type TSearchOffersDesktopResponse_1,
  createSearchOffersDesktopModel,
  fetchSearchOffersDesktop,
} from '@/repositories/generated/shared/search-offers/v3/search-offers-desktop';

type FetchServiceParams = {
  applicationContext: IQueryStateAppContext;
  cancellationToken: ICancellationToken;
  parameters: TSearchOffersDesktopRequest;
};

export function fetchSearchOffersDesktopService(params: FetchServiceParams): Promise<TSearchOffersDesktopResponse_1> {
  const {
    applicationContext: { httpApi, logger },
    parameters,
    cancellationToken,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createSearchOffersDesktopModel(parameters),
    '@/shared/store/serverSide/search-offers/v3/search-offers-desktop/internal/fetchService.ts',
    logger,
  );

  return fetchSearchOffersDesktop<ISearchOffersDesktopResponse200, ISearchOffersDesktopResponse400>({
    config: { cancellationToken },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
